import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {checkAuth} from '../../store/global/actions';
import Loader from '../Loader/Loader';

const Auth = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() => {
        (async () => {
            const {from, isProtected} = props.location.state ?? {};
            dispatch(checkAuth(from, isProtected, history));
        })();
    }, []);

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                width: '100%',
            }}
        >
            <Loader />
        </div>
    );
};

export default Auth;
